import { render, staticRenderFns } from "./project-list.vue?vue&type=template&id=318868b6&"
import script from "./project-list.vue?vue&type=script&lang=js&"
export * from "./project-list.vue?vue&type=script&lang=js&"
import style0 from "./project-list.vue?vue&type=style&index=0&id=318868b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports